import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MENU_CONFIG, MENU_ITEMS } from './menu.constants';
import { MenuService } from './menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  isLoggedIn = false;
  menuItems = MENU_ITEMS;
  availableLocales = ['en-US', 'zh-CN', 'zh-TW', 'ru-RU'];
  menuConfig = MENU_CONFIG;
  selectedIndex = 0;

  constructor(
    private router: Router,
    private menuService: MenuService
  ) { }

  ngOnInit() {
    this.menuService.currentPlatform$.subscribe(menu => {
      const index = this.menuItems.findIndex(item => item.icon === menu);
      if (index !== -1) {
        this.selectedIndex = index;
      }
    });
  }

  selectItem(index: number) {
    this.selectedIndex = index;
    const menu = this.menuItems[index].icon;
    this.menuService.changePlatform(menu);
  }
}
